import moment from 'moment';

import { IPatientIdentity } from 'interfaces/familyBookingTypes';

const DOB_FORMATS = ['YYYY-MM-DD', 'MM/DD/YYYY'];

type PatientRecordFields = Pick<
  IPatientIdentity,
  'id' | 'firstName' | 'lastName' | 'dob'
>;

type PatientIdentityFields = PatientRecordFields &
  Pick<IPatientIdentity, 'email'>;

const normalizeText = (text?: string | null) => text?.trim().toLowerCase();

const checkIsSameNameAndDob = (
  firstPatient: PatientRecordFields,
  secondPatient: PatientRecordFields
) =>
  moment(firstPatient.dob, DOB_FORMATS).isSame(
    moment(secondPatient.dob, DOB_FORMATS)
  ) &&
  normalizeText(firstPatient.firstName) ===
    normalizeText(secondPatient.firstName) &&
  normalizeText(firstPatient.lastName) ===
    normalizeText(secondPatient.lastName);

//--Links one person across the typed form and the clinic's records, where the email on file may differ--
export const checkIsMatchingPatientRecord = (
  firstPatient: PatientRecordFields,
  secondPatient: PatientRecordFields
) => {
  if (firstPatient.id && secondPatient.id) {
    return firstPatient.id === secondPatient.id;
  }

  return checkIsSameNameAndDob(firstPatient, secondPatient);
};

export const checkIsSamePatient = (
  firstPatient: PatientIdentityFields,
  secondPatient: PatientIdentityFields
) => {
  if (firstPatient.id && secondPatient.id) {
    return firstPatient.id === secondPatient.id;
  }

  return (
    checkIsSameNameAndDob(firstPatient, secondPatient) &&
    normalizeText(firstPatient.email) === normalizeText(secondPatient.email)
  );
};
